<template>
  <div class="AOC">
    <div class="splitView">
      <img src="/oss/aiyouth2024/images/2026-arena-banner.webp" id="banner" />
      <div class="preRules">
        恭喜你进入CodeQuest 全球青少年编程比赛，快来挑战一下吧！
        <br>
        <br>
        本次比赛同样是扣哒世界竞技场对抗赛，你可以和来自世界各地的选手们同台竞技。
        <br>
        <br>
        比赛时间 2026年8月15日 8:30 - 2026年8月30日 22:00。
        <br/>
        <br/>
        更多比赛相关说明请参考<a href="https://codequest.koudashijie.com">比赛官网（英文）</a>。
      </div>
      <my_button :value="'开始挑战'" :inputStyle="buttonStyle" @click.native="goto"></my_button>
      <!-- <my_button v-for="(url, index) in game_urls" :value="button_titles(index)" :inputStyle="buttonStyle" :disable="disable" :class="{passed: (problem_status[index] > 0)}" @click.native="goto(url)"></my_button> -->
      <!-- <vue_markdown :source="mdfile" id="rule"></vue_markdown> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import MyImage from '@/components/Image.vue';
import MyVideo from '@/components/Video.vue';
import MyButton from '@/components/Button.vue';
import VueMarkdown from 'vue-markdown'
import pdfvuer from 'pdfvuer'
import moment from 'moment'
export default {
  name: 'CQ',
  computed: {
    v() {
      return {
        src:'https://assets.koudashijie.com/videos/AI%E4%B8%96%E9%9D%92%E8%B5%9B%E5%A4%8D%E8%B5%9B%E8%A7%86%E9%A2%91%EF%BC%88%E6%97%A0%E7%BD%91%E5%9D%80%EF%BC%89.mp4'
      }
    },
    videoStyle() {
      return {
        width: '40vw',
        'margin-top': 0,
        height: 'auto'
      }
    },
    mdfile() {
      return rulemd
    },
    buttonStyle() {
      return {
        'border-radius': '5px',
        'margin-top': '5vh',
        'width': '8em',
        'margin-bottom': '10vh'
      }
    },
    game_urls () {
      return this.problem_urls.map(u =>
        this.$store.state.loginLink+`&redirect=${encodeURIComponent(u)}&accessToken=${this.$store.state.auth.token.token}`
      )
    },
    mettingNumber() {
      return '748287455'
    },
    /* myClassroom() { */
    /* return this.$store.state.auth.classroom*/
    /* return this.$store.state.classrooms[this.$store.state.auth.classroom[0].classroom_id] */
    /* } */

  },
  data () {
    return {
      disable: true,
      interval: null,
      user: null,

      numPages: 0,
      pdfdata: undefined,
      problem_urls: [],
      problem_status: [0, 0, 0, 0, 0]
    }
  },
  methods: {
    button_titles (index) {
      let origTitles = ['第一题', '第二题', '第三题', '第四题', '第五题']
      return this.problem_status[index] ? '已完成' : origTitles[index]
    }    ,
    getPdf () {
      this.pdfdata = pdfvuer.createLoadingTask('/oss/pdf/plusRule.pdf');
      this.pdfdata.then(pdf => {
        this.numPages = pdf.numPages
        console.log(this.numPages)
      })
    },
    goto() {
      console.log("click goto")
      let user = this.user || this.$store.state.auth.user
      let redirect = '/play/ladder/chaotic-crossing/clan/6a7c472d7be14f770e994095'
      let url = this.$store.state.loginLink + `&redirect=${encodeURIComponent(redirect)}` + `&accessToken=${this.$store.state.auth.token.token}`
      window.open(url, "_blank")
    },
    jump() {
      let user = this.user ||  this.$store.state.auth.user
      let redirect ='/play/level/resource-tycoon'
      let url = this.$store.state.loginLink + `&redirect=${encodeURIComponent(redirect)}` + `&accessToken=${this.$store.state.auth.token.token}`
      window.open(url)
    },
  },
  created() {

  },
  mounted() {
  },
  components: {
    my_image: MyImage,
    my_video: MyVideo,
    my_button: MyButton,
    pdf: pdfvuer,
    vue_markdown: VueMarkdown,
  }
}
</script>

<style scoped>
.AOC{
  margin-top: 6.5625vw;
  display: flex;
  flex-direction: column;
  align-items:center;
  font-size: 1.3vw;
}
.splitView{
  margin: auto;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.preRules {
  flex-basis: 60%;
}

.buttons{
  flex-basis: 40%;
  display: flex;
  flex-direction: column;
}
.passed{
  background-color: #43dd37;
}
.meeting {
  background-color: #6367ff;
}
.tip{
  color: #F17C67;
  font-weight: 500;
  font-size: 26px;
  margin-top: 20px;
}
#rule{
  width: 50vw;
}
.split{
  width: 20px;
  height: 5px;
  margin-left: 20px;
}
.rules{
  margin-top: 30px;
  width: 80%;
  border: 5px dotted black;
  padding: 20px 40px;
}
.faq{
  margin-top: 1em;
  margin-bottom: 1em;
}
.faq .q{
  font-weight: bold;
}
.faq .q::before{
  content: 'Q: '
}
.faq .a::before{
  content: 'A: '
}
.faq .img>img {
  margin: 20px 80px;
}
#banner {
  width: 80vw;
  margin-bottom: 4vh;
}
</style>
